/* content file: replace all html between <> </> with actual content */

export const Vision = () => { 
  return (
  <>
    <p>
      <strong>„GA-Lotse - Das Digitalisierungspaket der Zukunft“</strong> folgt der Idee, eine gemeinsame, einheitliche Software für die Mitarbeitenden der Fachabteilungen des ÖGD und anderer Ämter zu entwickeln, welche nach und nach Prozesse qualitativ verbessern und vereinheitlichen soll.
    </p>

    <p>
      Das Projekt wurde im Rahmen des "Pakts für den ÖGD" beschlossen und durch die Europäische Union und das hessische Ministerium für Familie, Senioren, Sport, Gesundheit und Pflegen gefördert.
    </p>
  </>    
  )
}